import { Trash2 } from "lucide-react";
import { ReactNode } from "react";
import { Button } from "../../../../components/ui/common/button";

interface SourceRecordCardProps {
  index: number;
  onRemove: () => void;
  children: ReactNode;
}

const SourceRecordCard = ({ index, onRemove, children }: SourceRecordCardProps) => (
  <div className="tw-rounded-lg tw-border tw-border-border tw-bg-primary/5 tw-p-4 tw-space-y-3">
    <div className="tw-flex tw-items-center tw-justify-between tw-gap-2">
      <p className="tw-text-[10px] tw-uppercase tw-tracking-wider tw-text-primary tw-font-medium">
        Record {index + 1}
      </p>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="tw-h-7 tw-w-7 tw-text-destructive hover:tw-text-destructive"
        aria-label={`Delete record ${index + 1}`}
        onClick={onRemove}
      >
        <Trash2 className="tw-h-3.5 tw-w-3.5" />
      </Button>
    </div>
    {children}
  </div>
);

export default SourceRecordCard;
